import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderMothersDay = function IconStaticReminderMothersDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 41"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.86 2.79v3.721M1 4.651h3.72m2.792 30.698v3.72M5.651 37.21h3.721M39.14 7.442v3.72m-1.86-1.86H41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.512,
    cy: 0.93,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.349,
    cy: 0.93,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.86,
    cy: 29.768,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M24 11.02v-.003a2.316 2.316 0 0 0-.343-1.73 2.257 2.257 0 0 0-.764-.71 2.337 2.337 0 0 0-.013-1.099 2.26 2.26 0 0 0-2.918-1.596l.236.713-.236-.712c-.296.098-.57.255-.804.46a2.38 2.38 0 0 0-.119.112 2.278 2.278 0 0 0-1.018-.277 2.294 2.294 0 0 0-.899.154 2.336 2.336 0 0 0-1.295 1.237c-.125.28-.194.583-.203.89a2.318 2.318 0 0 0 .225 1.066 2.383 2.383 0 0 0-.59.905 2.35 2.35 0 0 0-.138.89l.739-.029-.739.028c.012.303.082.601.209.876l.681-.312-.681.312a2.272 2.272 0 0 0 1.3 1.191 2.267 2.267 0 0 0 1.052.11 2.272 2.272 0 0 0 1.47 1.233c.294.078.6.096.902.054l-.104-.743.104.743a2.328 2.328 0 0 0 1.53-.895l-.595-.457.595.457a2.37 2.37 0 0 0 .448-1.001c.356-.05.7-.183 1-.392.5-.347.848-.877.968-1.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M19.162 10.773a.93.93 0 1 0 .892-1.633.93.93 0 0 0-.892 1.633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m32.445 22.388.002-.004c.34-.506.471-1.126.356-1.726a2.258 2.258 0 0 0-.427-.952 2.334 2.334 0 0 0 .415-1.017 2.29 2.29 0 0 0-.05-.926 2.259 2.259 0 0 0-2.017-1.68l-.06.748.06-.747a2.336 2.336 0 0 0-.92.112 2.388 2.388 0 0 0-.153.056 2.278 2.278 0 0 0-.83-.651 2.295 2.295 0 0 0-.888-.208 2.337 2.337 0 0 0-1.675.636 2.354 2.354 0 0 0-.741 1.63c-.002.06-.002.12.001.18a2.357 2.357 0 0 0-1.369 1.37l.692.262-.692-.261a2.314 2.314 0 0 0-.148.888l.75-.023-.75.023a2.274 2.274 0 0 0 .735 1.603 2.265 2.265 0 0 0 .926.51 2.304 2.304 0 0 0 .287 1.024 2.26 2.26 0 0 0 1.397 1.084l.194-.724-.194.724c.294.079.6.098.902.058a2.36 2.36 0 0 0 .856-.288l-.37-.652.37.652a2.373 2.373 0 0 0 .802-.747c.348.092.716.103 1.074.028a2.362 2.362 0 0 0 1.465-.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M28.084 20.277a.93.93 0 1 0 1.458-1.156.93.93 0 0 0-1.458 1.156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m29.484 15.504.002-.003c.276-.544.33-1.176.144-1.757a2.258 2.258 0 0 0-.54-.893 2.36 2.36 0 0 0 .288-1.06 2.289 2.289 0 0 0-.674-1.685 2.26 2.26 0 0 0-1.694-.65l.031.75-.031-.75a2.336 2.336 0 0 0-1.044.297 2.26 2.26 0 0 0-.903-.546 2.293 2.293 0 0 0-.908-.097 2.336 2.336 0 0 0-1.585.834 2.357 2.357 0 0 0-.439.8 2.32 2.32 0 0 0-.075 1.088 2.365 2.365 0 0 0-1.192 1.526l.717.175-.718-.175c-.071.294-.085.6-.039.9l.741-.115-.741.114a2.274 2.274 0 0 0 .925 1.502 2.266 2.266 0 0 0 .98.394 2.284 2.284 0 0 0 .41.981 2.26 2.26 0 0 0 1.519.907l.104-.743-.104.743c.3.042.607.024.901-.052a2.36 2.36 0 0 0 .816-.39l-.448-.602.448.602a2.373 2.373 0 0 0 .705-.84c.356.05.723.016 1.07-.102a2.36 2.36 0 0 0 1.334-1.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M24.9 13.94a.93.93 0 1 0 1.305-1.326.93.93 0 0 0-1.305 1.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m9.88 29.177 1.34 1.32 7.271-6.08 5.946.595a2.298 2.298 0 0 0 1.653-.398c.467-.336.78-.843.879-1.423a2.512 2.512 0 0 0-.345-1.72 2.696 2.696 0 0 0-1.392-1.136 2.21 2.21 0 0 0 .713-1.394 2.525 2.525 0 0 0-.36-1.6 2.7 2.7 0 0 0-1.274-1.092 2.447 2.447 0 0 0-1.62-.098 2.476 2.476 0 0 0-.154-1.597 2.72 2.72 0 0 0-1.104-1.235 2.547 2.547 0 0 0-1.583-.344 2.231 2.231 0 0 0-1.383.693 2.697 2.697 0 0 0-1.163-1.344 2.507 2.507 0 0 0-1.707-.304 2.192 2.192 0 0 0-1.396.888 2.294 2.294 0 0 0-.386 1.635l.701 5.955-5.946 7.387z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m14.423 20.593 3.975 3.918m0 0 1.997 3.274m-1.997-3.274-.624 4.609"
  }));
};